var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-spinner', {
    staticClass: "align-middle"
  }), _c('div', {
    staticClass: "text-center"
  }, [_vm._v(" 處理中... ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }